export default __webpack_public_path__ + "static/media/Vehicle Moving Service.8729f8f5.png";